import React from "react"
import SvgSpriteIcon from "shared/SvgSpriteIcon"

const AllFormGroupingsAreEmpty = () => (
  <div className="flex flex-col w-full items-center">
    <SvgSpriteIcon iconName="forms" className="w-16 h-16 mb-4 header-icon" />
    <span>There are no forms with the selected options.</span>
  </div>
)

export default AllFormGroupingsAreEmpty
